import {APIProvider} from '@vis.gl/react-google-maps';
import {ReactNode} from 'react';

import {AdminsProvider} from '@/providers/components/adminsProvider';
import {BrandsProvider} from '@/providers/components/brandsProvider';
import {DistributorsProvider} from '@/providers/components/distributorsProvider';
import {MarketsProvider} from '@/providers/components/marketsProvider';
import {ProductsProvider} from '@/providers/components/productsProviders';
import {RetailersProvider} from '@/providers/components/retailersProvider';
import {SpeculatorsProvider} from '@/providers/components/speculatorsProvider';

export type AppProvidersPropsT = {
  children: ReactNode;
};

function AppProviders({children}: AppProvidersPropsT) {
  return (
    <APIProvider apiKey={import.meta.env.VITE_GOOGLE_MAPS_API_KEY}>
      <AdminsProvider>
        <RetailersProvider>
          <DistributorsProvider>
            <BrandsProvider>
              <SpeculatorsProvider>
                <MarketsProvider>
                  <ProductsProvider>{children}</ProductsProvider>
                </MarketsProvider>
              </SpeculatorsProvider>
            </BrandsProvider>
          </DistributorsProvider>
        </RetailersProvider>
      </AdminsProvider>
    </APIProvider>
  );
}

export default AppProviders;
